import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { coercedDate } from '../../../utils/coerced-date';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { driverVehicleLinkSchema } from '../schemas/driver-vehicle-link.schema';

/**
 * Returns the Driver Vehicle Links for a Driver-Based Account
 * @param driverIds The IDs of the Drivers being requested
 * @returns The Driver Vehicle Link
 */
export function postDriversVehicleLinks(this: unknown, driverIds: string[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).driversVehicleLinksUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify({ driverIds }),
      })
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string().nullable(),
        data: z.object({
          lastModifiedOn: coercedDate.optional(),
          driverVehicleLinks: z.array(driverVehicleLinkSchema),
        }),
        error: z
          .object({
            message: z.string().optional(),
            detail: z.string().optional(),
            errorCode: z.number(),
          })
          .optional(),
      })
    )
  );
}
